<template lang="pug">
  div.e-table-checked-list
    div.body.body-table.body--noPadding
      div.table-choose-panel
        div.toolbar-table
          div(v-if="listTypes && listTypes.length>0").parameters
            //div Тип заказчика
            select(v-model="currentListType")
              option(v-for="option in listTypes" :value="option.id") {{option.name}}
          div(v-else).select
          div.toolbar.toolbar--modal
            div.line
              div.search
                input(
                type="search"
                v-model="searchModel"
                :placeholder="placeholder"
                v-on:keyup.enter.prevent="letSearch"
                )

    div.body-wrapper
      div.body.body--noPadding
        div.col
          div.col-block
            div.fixed-header.table
              div.table-checked-list-head
                table(ref="tableHeader")
                  colgroup
                    col(
                    v-for="(item, fieldName) in showedColumns"
                    :width="item.width || defaultColWidth"
                    )
                    col(
                    :width="actionColumnWidth"
                    )
                  thead
                    th(v-for="field in showedColumns") {{field.label}}
                    th
                      div.flex-table
                        label {{selectType==='checkbox' ? 'Выбрать все' : ''}}
                        label.checked
                          input(v-if="selectType==='checkbox'" :type="selectType" ref="selectAll" @change="selectAll($event)").checkbox
                          span
                div.progress-wrapper
                  e-progress(:loading="loading")
              e-perfect-scrollbar(
              ref="scrollbar"
              :emitTypes="['vue']"
              @ps-scroll-x="scrollHandler($event.event)"
              :config="{suppressScrollY: false, suppressScrollX: false}"
              ).table-checked-list-body-scroll-wrapper
                div(ref="tableBody").table-checked-list-body
                  table
                    colgroup
                      col(
                      v-for="(item, fieldName) in showedColumns"
                      :width="item.width || defaultColWidth"
                      )
                      col(
                      :width="actionColumnWidth"
                      )
                    tbody(v-if="items && items.data && items.data.length > 0")
                      tr(
                      v-for="item in items.data"
                      )
                        // @click="selectItem(item)"
                        td(
                        v-for="(field, fieldName) in showedColumns"
                        ).column
                          div(v-if="item[fieldName] && item[fieldName].name") {{ item[fieldName].name }}
                          div(v-else-if="Array.isArray(item[fieldName])" v-e-array-as-line="item[fieldName]")
                          div(v-else v-html="item[fieldName]")
                        td.actions
                          label(:class="inputWrapperClass")
                            input(v-if="selectType==='radio'" v-model="checkedItems[currentListType]" :value="item.id" type="radio" class="radio")
                            input(v-else v-model="checkedItems[currentListType]" :value="item.id" type="checkbox" class="checkbox")
                            span
                    tbody(v-else-if="error")
                      tr
                        td(colspan=100)
                          span.text-muted.text-left.table-error {{error}}
                        td
                    tbody(v-else)
                      tr
                        td(colspan=100)
                          span(v-if="isFetched").text-muted.text-left Ничего не найдено...
                        td

      div(v-if="showPaginate").footer-nav
        e-pagination(
        v-if="items && items._meta"
        :auto="false"
        @paginate="paginate"
        :currentPage="items._meta.currentPage"
        :totalCount="items._meta.totalCount"
        :perPage="items._meta.perPage"
        :pageCount="items._meta.pageCount"
        )
</template>

<script>
  import userFriendlyEr from '../../utils/userFriendlyEr.js'

  export default {
    name: 'e-table-checked-list',
    data () {
      this._savedModels = {}
      return {
        loading: false,
        currentListType: null,
        searchModel: '',
        q: '',
        checkedItems: null,
        paginateObj: null,
        error: null,
        items: null,
        isFetched: false
      }
    },
    created () {
      this.init()
      this.fetchData()
    },
    props: {
      selectType: {
        type: String,
        default: 'checkbox'
      },
      earlyCheckedItems: {
        type: Object,
        default: function () {
          return {}
        }
      },
      endpoint: {
        type: Function,
        default: function () {
          return {url: null, fields: {}}
        }
      },
      showPaginate: {
        type: Boolean,
        default: true
      },
      defaultListType: {
        type: String,
        default: 'default'
      },
      /*
      [{ id: 'source', name: 'Отходообразователь'}]
       */
      listTypes: {
        type: Array,
        default: function () {
          return []
        }
      },
      transformUserFriendlyEr: {
        type: Function,
        default: (e, endpoint) => userFriendlyEr.recognize(e, endpoint)
      },
      defaultColWidth: {
        type: [Number, String],
        default: '50%'
      },
      actionColumnWidth: {
        type: Number,
        default: 180
      },
      placeholder: {
        type: String,
        default: null
      }
    },
    watch: {
      currentListType: 'fetchData',
      checkedItems: {
        handler: function (newVal) {
          this.$emit('checkedChange', {
            checked: this.checkedItems,
            checkedLen: this.calcObjectsArrayLen(this.checkedItems),
            checkedModels: this.getModels(this.checkedItems)
          })
        },
        immediate: true,
        deep: true
      }
    },
    computed: {
      showedColumns () {
        if (this.currentListEndpoint.fields) {
          return this.currentListEndpoint.fields
        } else if (this.items && this.items._meta && this.items._meta.fields) {
          return this.items._meta.fields
        }
        return {}
      },
      inputWrapperClass () {
        if (this.selectType === 'radio') {
          return 'radioButton'
        }
        return 'checked'
      },
      currentListEndpoint () {
        return this.endpoint(this)
      },
      storageItems () {
        return this.$store.getters.readUrlEndpoint(this.currentListEndpoint.url)
      }
    },
    methods: {
      scrollHandler ($event) {
        let {scrollLeft = 0} = $event.target
        this.$refs.tableHeader.style.marginLeft = `-${scrollLeft}px`
      },
      selectItem (item) {
        if (Array.isArray(this.checkedItems[this.currentListType])) {
          this.checkedItems[this.currentListType].push(item.id)
        } else {
          this.$set(this.checkedItems, this.currentListType, item.id)
        }
      },
      getModels (checkedItems) {
        if (!this._savedModels[this.currentListType]) {
          this._savedModels[this.currentListType] = {}
        }
        if (!this.items) {
          return this._savedModels
        }
        
        this.items.data.forEach(item => {
          if (Array.isArray(checkedItems)) {
            // if (checkedItems.indexOf(item.id) > -1) {
            this._savedModels[this.currentListType][item.id] = item
            // }
          } else {
            // if (+checkedItems === +item.id) {
            this._savedModels[this.currentListType][item.id] = item
            // }
          }
        })
        return this._savedModels
      },
      init () {
        // set default type
        if (this.defaultListType && !this.currentListType) {
          // drop link
          this.currentListType = JSON.parse(JSON.stringify(this.defaultListType))
        }
        // create checkedItems model: {type1:[ids], type2: [ids] }
        if (!this.checkedItems) {
          let tmp = {}
          this.listTypes.forEach(v => {
            tmp[v.id] = []
          })
          if (Object.keys(tmp).length === 0) {
            if (this.selectType === 'checkbox') {
              tmp[this.currentListType] = []
            } else {
              tmp[this.currentListType] = []
            }
          }
          this.checkedItems = tmp
        }
        // set early setted items
        if (this.earlyCheckedItems && Object.keys(this.earlyCheckedItems).length > 0) {
          for (let type in this.checkedItems) {
            if (this.earlyCheckedItems[type]) {
              this.checkedItems[type] = this.earlyCheckedItems[type]
            }
          }
        }
      },
      selectAll ($event) {
        let el = $event.srcElement || $event.target
        if (el.checked) {
          this.items.data.forEach(v => {
            this.checkedItems[this.currentListType].push(v.id)
          })
        } else {
          this.items.data.forEach(v => {
            this.checkedItems[this.currentListType] = this.checkedItems[this.currentListType].filter(item => item !== v.id)
          })
        }
      },
      paginate ($event) {
        this.paginateObj = $event
        this.fetchData()
      },
      letSearch () {
        if (this.searchModel) {
          // drop link
          this.q = JSON.parse(JSON.stringify(this.searchModel))
          this.$emit('onSearch', this.q)
        } else {
          this.q = ''
          this.$emit('onSearch', '')
        }
        this.fetchData()
      },
      calcObjectsArrayLen (obj) {
        let len = 0
        for (let key in obj) {
          len = +len + obj[key].length
        }
        return len
      },
      afterFetch () {
        // чтобы не скрывать все данные при обновлении таблицы
        this.items = Object.assign({}, this.storageItems || {})

        this.isFetched = true

        if (this.$refs.selectAll) {
          this.$refs.selectAll.checked = false
        }
        this.refreshScrollbar()
        // this.$bar.finish()
      },
      refreshScrollbar (delay = 50) {
        setTimeout(() => {
          if (this.$refs.scrollbar) {
            // setScrollTop called update
            this.$refs.scrollbar.setScrollTop(0)
          }
        }, delay)
      },
      fetchData () {
        this.loading = true
        this.error = null
        const endpoint = this.currentListEndpoint.url
        this.$store.dispatch('updateUrlEndpoint', {
          endpoint,
          params: {
            disableGlobalError: true
          }
        }).then(() => {
          this.afterFetch()
          this.loading = false
        }).catch(e => {
          console.error(e)
          this.afterFetch()
          this.error = this.transformUserFriendlyEr(e, endpoint)
          this.loading = false
        })
      }
    }
  }
</script>
